import { createContext } from "react";
import type { TenantPublicResponse, TenantSpacePublic } from "@/types";

export interface TenantContextValue {
  /** True when hostname resolves to an explicit tenant subdomain */
  isTenantSite: boolean;
  /** Slug from DNS subdomain, null on www */
  tenantSlug: string | null;
  /** Business tenant slug for the current host (www → platform slug) */
  effectiveTenantSlug: string;
  /** True when effective tenant is the main-tenant (platform) */
  isMainTenantHost: boolean;
  isPlatform: boolean;
  tenant: TenantPublicResponse | null;
  space: TenantSpacePublic | null;
  loading: boolean;
  error: Error | null;
}

export const TenantContext = createContext<TenantContextValue | null>(null);
